document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function publish(eventName, payload) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var result = window.Shopify.analytics.publish('vegas_kings:' + eventName, payload || {});
    if (result && typeof result.catch === 'function') result.catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-vk-event]');
    if (tracked) {
      var requestedEvent = tracked.getAttribute('data-vk-event');
      var eventMap = {
        access_cta: 'access_cta_clicked',
        record_cta: 'record_cta_clicked',
        package_view: 'package_link_clicked',
        monthly_inquiry_start: 'monthly_inquiry_started'
      };
      if (eventMap[requestedEvent]) {
        publish(eventMap[requestedEvent], {
          location: tracked.getAttribute('data-vk-location') || '',
          package: tracked.getAttribute('data-vk-package') || ''
        });
      }
    }

    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname || !url.hash) return;
    var target = document.querySelector(url.hash);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    history.pushState(null, '', url.hash);
  });

  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var isOpen = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });
    nav.addEventListener('click', function (event) {
      if (!event.target.closest('a')) return;
      navToggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    });
  }

  document.querySelectorAll('[data-access-selector]').forEach(function (selector) {
    var tabs = Array.prototype.slice.call(selector.querySelectorAll('[data-access-tab]'));
    var panels = Array.prototype.slice.call(selector.querySelectorAll('[data-access-panel]'));

    function activate(tab, setFocus) {
      var value = tab.getAttribute('data-access-tab');
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-access-panel') === value);
      });
      publish('access_window_selected', { window: value });
      if (setFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab, false); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex], true);
      });
    });
  });

  document.querySelectorAll('input[type="date"][data-allowed-days]').forEach(function (input) {
    var allowedDays = input.getAttribute('data-allowed-days').split(',').map(Number);
    var error = input.parentElement.querySelector('[data-date-error]');
    var form = input.closest('form');

    function validateDate() {
      if (!input.value) {
        input.setCustomValidity('');
        if (error) error.hidden = true;
        return true;
      }
      var parts = input.value.split('-').map(Number);
      var chosen = new Date(parts[0], parts[1] - 1, parts[2]);
      var valid = allowedDays.indexOf(chosen.getDay()) !== -1;
      if (valid) {
        input.setCustomValidity('');
        if (error) error.hidden = true;
        return true;
      }
      var message = allowedDays.length === 1 && allowedDays[0] === 6
        ? 'Choose a Saturday.'
        : allowedDays.length === 1 && allowedDays[0] === 0
          ? 'Choose a Sunday.'
          : 'Choose a Monday through Friday date.';
      input.setCustomValidity(message);
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      return false;
    }

    input.addEventListener('change', validateDate);
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!validateDate()) {
          event.preventDefault();
          input.reportValidity();
          input.focus();
        }
      });
    }
  });

  var params = new URLSearchParams(window.location.search);
  if (params.get('interest') === '30-day-private') {
    var topic = document.querySelector('[data-contact-topic]');
    var subject = document.querySelector('[data-contact-subject]');
    if (topic) topic.value = '30-Day Private access';
    if (subject) subject.value = '30-Day Private Access Request';
  }

  var success = document.querySelector('[data-form-success]');
  if (success) {
    publish('monthly_inquiry_succeeded', { form: 'contact' });
    success.focus();
  }
})();
